module.exports = __webpack_public_path__ + "img/en-en.d7ec310f.svg";